import { grey } from '@mui/material/colors';

export const paletteBlue = {
  50: '#e3f2ff',
  100: '#bbddff',
  200: '#8fc8ff',
  300: '#61b2ff',
  400: '#3ea2ff',
  500: '#1e92fe',
  600: '#2184ef',
  700: '#2171db',
  800: '#2060c9',
  900: '#2141a8',
} as const;

export const paletteGreyBlue = {
  50: '#f4f5f6',
  100: '#eef0f2',
  200: '#d3dbdf',
  300: '#b6c3ca',
  400: '#98abb5',
  500: '#8198a4',
  600: '#5e7683',
  700: '#4e626c',
  800: '#404f57',
  900: '#2e393f',
} as const;

export const paletteRed = {
  50: '#ffefef',
  100: '#ffdfde',
  200: '#ffccc9',
  300: '#fab0aa',
  400: '#f28479',
  500: '#e74c3c',
  600: '#d8443a',
  700: '#c63b34',
  800: '#b9352e',
  900: '#a92d24',
} as const;

export const paletteOrange = {
  50: '#fffae4',
  100: '#fef2ba',
  200: '#ffeb8e',
  300: '#ffe360',
  400: '#ffdb32',
  500: '#ffd32b',
  600: '#ffc523',
  700: '#ffb932',
  800: '#ffa217',
  900: '#ff840a',
} as const;

export const paletteGreen = {
  50: '#f6fbe5',
  100: '#e8f5bf',
  200: '#d9ef94',
  300: '#cae867',
  400: '#bee242',
  500: '#b4dd0d',
  600: '#a9cb00',
  700: '#80b000',
  800: '#518800',
  900: '#2c6800',
} as const;

export const paletteGrey = {
  ...grey,
  50: '#f7f7f7',
  100: '#efefef',
  200: '#dfdfdf',
  300: '#c4c4c4',
  400: '#a6a6a6',
  500: '#979797',
  600: '#6e6e6e',
  700: '#525252',
  800: '#313131',
  900: '#1d1d1d',
} as const;
